export default __webpack_public_path__ + "static/media/df_logo.7bda10e4.png";